module.exports = __webpack_public_path__ + "img/Chatroom_Single_Frame0001.78be83f6.png";